module.exports = __webpack_public_path__ + "static/Dotdigital-0c3a751bdde9308ac56e16a81a595e57.svg";